import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=4c70946b&scoped=true&"
import script from "./Bubble.vue?vue&type=script&lang=js&"
export * from "./Bubble.vue?vue&type=script&lang=js&"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=4c70946b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70946b",
  null
  
)

export default component.exports